import { useSelector } from 'react-redux';

import { useEnableLtlRegistration } from '../../feature-flags/hooks/use-enable-ltl-registration';
import Global from '../../store/global-selectors';

// House-account quoting is gated behind enable-ltl-registration. Without that flag a seller can
// only quote freight through their own connected provider.
export const useCanQuoteFreight = (): boolean => {
  const isLtlRegistrationEnabled = useEnableLtlRegistration();
  const sellerFreightProviders = useSelector(Global.selectSellerFreightProviders);

  return isLtlRegistrationEnabled || sellerFreightProviders.length > 0;
};
